module.exports = __webpack_public_path__ + "img/busca-aqui-logo.1d140ffc.jpeg";